import VueToastr from '@/components/Toast/Toastr.vue'
export default VueToastr